// Razorpay client helper - opens checkout, calls backend for order + verify
import axios from 'axios';
import { activatePrime } from './quota';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

function loadScript(src) {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const s = document.createElement('script');
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function fetchPaymentConfig() {
  const res = await axios.get(`${API}/payment/config`);
  return res.data;
}

/**
 * Open Razorpay checkout for a given plan ('test' or 'monthly').
 * Returns a promise that resolves with the prime activation on success.
 */
export async function startCheckout({ planId, user = {} }) {
  const ok = await loadScript('https://checkout.razorpay.com/v1/checkout.js');
  if (!ok) throw new Error('Failed to load Razorpay checkout');

  // 1. Create order on backend
  const { data: order } = await axios.post(`${API}/payment/order`, { plan_id: planId });

  // 2. Open checkout
  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: order.key_id,
      amount: order.amount,
      currency: order.currency,
      order_id: order.order_id,
      name: 'Brahmastra AI',
      description: `${order.plan_label} — ${order.duration_days} days`,
      image: '/favicon.ico',
      theme: { color: '#34e0b3' },
      prefill: {
        name: user.name || '',
        email: user.email || '',
        contact: user.contact || '',
      },
      notes: { plan_id: planId },
      handler: async (response) => {
        try {
          const verify = await axios.post(`${API}/payment/verify`, {
            razorpay_order_id: response.razorpay_order_id,
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_signature: response.razorpay_signature,
            plan_id: planId,
          });
          const { plan_label, expires_at, payment_id } = verify.data;
          activatePrime({ id: planId, label: plan_label }, expires_at, payment_id);
          resolve(verify.data);
        } catch (e) {
          reject(e);
        }
      },
      modal: {
        ondismiss: () => reject(new Error('Payment cancelled')),
      },
    });
    rzp.on('payment.failed', (resp) => {
      reject(new Error(resp.error?.description || 'Payment failed'));
    });
    rzp.open();
  });
}
